const TOOL_RESULT_QUERY_TOOL_ID = "alpharun:tool_result_query";
const TOOL_RESULT_QUERY_TOOL_NAME = "tool_result_query";
const TOOL_RESULT_QUERY_TOOL_DISPLAY_NAME = "Stored result lookup";
const TOOL_RESULT_STORE_THRESHOLD = 2560;
const TOOL_RESULT_QUERY_TOOL_DESCRIPTION = `Extracts information needed to answer a specific question from a previously stored tool result. Provide the \`result_id\` and a natural-language \`query\`. Returns a voice-ready answer with supporting facts. Use this for each new user question so you have all relevant information. Do not mention the \`tool_result_query\` tool to the user.

The \`query\` is answered by a module that cannot see the conversation, so it has to stand on its own. Carry over whatever context the question depends on: resolve pronouns and references like "that one", and spell out any details that matter, such as names, identifiers, amounts and absolute dates. Some questions need little of this ("What is the cancellation policy?" is already self-contained), others need a lot \u2014 ask "What is the name of the current health plan of member John Doe, phone number +19161234567?" rather than "What about his plan?".`;
const TOOL_RESULT_QUERY_SYSTEM_PROMPT = `You are an information extraction and summarization module for a voice agent.

You will be given (A) the tool call that was made, including the arguments it was called with, (B) the tool result payload it returned, and (C) a query from the voice agent.

Your job is to extract ONLY the minimum necessary information from the payload to answer the query.

You cannot see the conversation between the voice agent and the user; the tool call and its arguments are the only context you have for what the user is asking about, so use them to interpret the query.

Requirements:
- Be accurate and factual; do not guess or invent. If the answer is not present, say so and suggest what to ask next.
- Keep output short, ready to be spoken out loud by the voice agent, and focused on the query.
- Do not output the full payload, large lists, or complex formatting. Summarize and select.
- Prefer concrete fields/data when available.
- If multiple conflicting values exist, note the conflict briefly.
- If the query is ambiguous and the tool call arguments do not resolve it, answer for the most likely reading and briefly say what you assumed.`;
const TOOL_RESULT_QUERY_PARAMETERS = {
  type: "object",
  properties: {
    result_id: { type: "string" },
    query: { type: "string" }
  },
  required: ["result_id", "query"],
  additionalProperties: false
};
const STORED_RESULT_MESSAGE = "The tool result has been stored. Use the `tool_result_query` tool with this `result_id` to extract relevant information for a user question.";
function buildStoredToolResultReference(resultId) {
  return JSON.stringify({
    status: "success",
    result_id: resultId,
    message: STORED_RESULT_MESSAGE
  });
}
function buildToolResultQueryOutput(resultId, query, answer) {
  return JSON.stringify({ result_id: resultId, query, answer });
}
const TOOL_RESULT_NOT_FOUND_OUTPUT = "No tool result found for the given `result_id`";
const TOOL_RESULT_QUERY_FAILED_OUTPUT = "An error occurred while querying the tool result. Please try again later.";
export {
  TOOL_RESULT_NOT_FOUND_OUTPUT,
  TOOL_RESULT_QUERY_FAILED_OUTPUT,
  TOOL_RESULT_QUERY_PARAMETERS,
  TOOL_RESULT_QUERY_SYSTEM_PROMPT,
  TOOL_RESULT_QUERY_TOOL_DESCRIPTION,
  TOOL_RESULT_QUERY_TOOL_DISPLAY_NAME,
  TOOL_RESULT_QUERY_TOOL_ID,
  TOOL_RESULT_QUERY_TOOL_NAME,
  TOOL_RESULT_STORE_THRESHOLD,
  buildStoredToolResultReference,
  buildToolResultQueryOutput
};
//# sourceMappingURL=toolResultQuery.js.map
